import { createRouter, createWebHistory } from 'vue-router'
import i18n from '@/i18n'

const routes = [
  {
    path: '/handle/login/:reference',
    name: 'handlelogin',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/select',
    name: 'selectcustomerservice',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/csam/register',
    name: 'csamregister',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/register/profile',
    name: 'itsmeproprofile',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/register/details',
    name: 'itsmeprodetails',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/register/profile',
    name: 'itsmeprofile',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/permit/new',
    name: 'permitcreateadmin',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/select',
    name: 'selectcustomerservice',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/search',
    name: 'searchpermits',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/reports',
    name: 'csreports',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/tasklist',
    name: 'cstaskmanager',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/tasklist/:reference',
    name: 'cstaskmanagerdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/templates',
    name: 'cstemplatemanager',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/logging',
    name: 'cshistorymanager',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/vouchers',
    name: 'csvouchers',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/vouchers/create',
    name: 'csvoucherscreate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/vouchers/:id',
    name: 'csvoucherdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/profile',
    name: 'profile',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/change-password',
    name: 'changepassword',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/profile',
    name: 'csresidentprofile',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/change-password',
    name: 'csresidentchangepassword',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/profile',
    name: 'csproprofile',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/change-password',
    name: 'csprochangepassword',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/profile',
    name: 'proprofile',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/change-password',
    name: 'prochangepassword',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/notifications',
    name: 'notifications',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/notifications',
    name: 'pronotifications',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/usertype',
    name: 'usertype',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/dashboard',
    name: 'dashboard',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/dashboard',
    name: 'csresidentdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/dashboard',
    name: 'prodashboard',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/dashboard',
    name: 'csprodashboard',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/vehicles',
    name: 'provehicles',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/permits',
    name: 'propermits',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/unit/new',
    name: 'prounitnew',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/manager/new',
    name: 'promanagernew',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/vehicle/:reference',
    name: 'vehicleupdatepro',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/vehicle/:reference',
    name: 'vehicleupdateprocs',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/vehicle/new',
    name: 'vehiclecreatepro',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/vehicle/:reference',
    name: 'vehicleupdate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/vehicle/:reference',
    name: 'vehicleupdatecs',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/vehicle/new',
    name: 'vehiclecreate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/vehicle/new',
    name: 'vehiclecreateresidentcs',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/vehicle/new',
    name: 'vehiclecreateprocs',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/',
    name: 'permitsoverview2',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/residents',
    name: 'residentsoverview',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/vehicles',
    name: 'vehiclesoverview',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/permits',
    name: 'permitsoverview',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/new',
    name: 'csresidentcreate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/company/new',
    name: 'cscompanycreate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/permit/:reference',
    name: 'cspermitdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/permit/:reference',
    name: 'propermitdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/permit/:reference/document',
    name: 'cspermitdetailprodocument',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/permit/:reference/document',
    name: 'cspermitdetailresidentdocument',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/permit/:reference',
    name: 'cspermitdetailpro',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/permit/:reference/cancel',
    name: 'propermitcancel',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/permit/:reference',
    name: 'permitdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/permit/:reference',
    name: 'csresidentpermitdetail',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/permit/:reference/cancel',
    name: 'permitcancel',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/permit/:reference/cancel',
    name: 'csresidentpermitcancel',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/permit/:reference/cancel',
    name: 'cspropermitcancel',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/permit/letter',
    name: 'permitletter',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/resident/permit/new',
    name: 'permitcreate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/permit/new',
    name: 'permitcreatecspro',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/permit/new',
    name: 'permitcreatecs',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/pro/permit/new',
    name: 'propermitcreate',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/resident/permit/renew/:reference',
    name: 'permitrenewcs',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/cs/pro/permit/renew/:reference',
    name: 'permitrenewcspro',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/itsme1',
    name: 'itsme1',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/itsme2',
    name: 'itsme2',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/itsme3',
    name: 'itsme3',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/csam1',
    name: 'csam1',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/csam2',
    name: 'csam2',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/csam3',
    name: 'csam3',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/fr',
    redirect: '/login/fr'
  },
  {
    path: '/nl',
    redirect: '/login/nl'
  },
  {
    path: '/en',
    redirect: '/login/en'
  },
  {
    path: '/login/user',
    name: 'loginuser',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/login/:lang?',
    name: 'login',
    component: () => import('../views/_new/BaseView.vue'),
    beforeEnter: (to, from, next) => {
      const supported = ['fr', 'nl', 'en']
      const lang = to.params.lang
      if (typeof lang === 'string' && supported.includes(lang)) {
        try {
          localStorage.setItem('selectedLanguage', lang)
          i18n.global.locale = lang
        } catch (e) {
          // no-op if localStorage not available
        }
      }
      next()
    }
  },
  {
    path: '/internal',
    name: 'logininternal',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/_new/BaseView.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/auth/LogoutView.vue')
  },
  {
    path: '/account/validate/:uid',
    name: 'accountValidate',
    component: () => import('../views/_new/BaseView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  }
})

export default router
